module.exports = __webpack_public_path__ + "static/media/Inspiron4.66684321.png";